import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  toggleCompanyForm,
  toggleCompanyFormYear1,
  toggleCompanyFormYear2,
  toggleCompanyFormYear3,
} from "../../Redux/Actions/activeCompanyForm";
import { useSelector, useDispatch } from "react-redux";
import { useTrialAuth } from "../../Context/TrialAuthContext";

const CompanyFormButtonTrial = () => {
  const context = useTrialAuth();
  const { salaryCalculationData, editCompanyForm } = context || {};
  const [currentCompanyForm, setCurrentCompanyForm] = useState("enskildFirma");
  const activeYear = useSelector((state) => state.year);

  const dispatch = useDispatch();

  const businessHandler = (value) => {
    if (activeYear.year === "year1") {
      dispatch(toggleCompanyFormYear1(value));
      editCompanyForm({ companyFormYear1: value });
    }
    if (activeYear.year === "year2") {
      dispatch(toggleCompanyFormYear2(value));
      editCompanyForm({ companyFormYear2: value });
    }
    if (activeYear.year === "year3") {
      dispatch(toggleCompanyFormYear3(value));
      editCompanyForm({ companyFormYear3: value });
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (salaryCalculationData && salaryCalculationData.length > 0) {
        const activeCompany = salaryCalculationData[0].object.activeCompany;
        let companyFormValue = "enskildFirma";

        if (activeYear.year === "year1") {
          companyFormValue = activeCompany.companyFormYear1;
        } else if (activeYear.year === "year2") {
          companyFormValue = activeCompany.companyFormYear2;
        } else if (activeYear.year === "year3") {
          companyFormValue = activeCompany.companyFormYear3;
        }

        setCurrentCompanyForm(companyFormValue);
        dispatch(toggleCompanyForm(companyFormValue));
      }
    }
    return () => {
      isMounted = false;
    };
  }, [activeYear.year, dispatch, salaryCalculationData]);

  // Don't render if context not ready
  if (!context || !salaryCalculationData || !editCompanyForm) {
    return null;
  }

  return (
    <Row className="d-flex align items center justify-content-center">
      <Col
        xs={15}
        className={`
          mt-2 p-1 text-center responsive-fontsize rounded-3 fw-bold
          ${
            currentCompanyForm === "enskildFirma"
              ? "company-form-button-focused"
              : "company-form-button"
          }
        `}
        onClick={() => {
          businessHandler("enskildFirma");
        }}
      >
        Ensk. Firma/HB
      </Col>

      <Col
        xs={15}
        className={`
          mt-2 p-1 text-center responsive-fontsize rounded-3 fw-bold 
          ${
            currentCompanyForm === "aktiebolag"
              ? "company-form-button-focused"
              : "company-form-button"
          }
        `}
        onClick={() => {
          businessHandler("aktiebolag");
        }}
      >
        Aktiebolag
      </Col>
    </Row>
  );
};
export default CompanyFormButtonTrial;
